export default [
  {
    path: '/admin/apply/user/list',
    name: 'UserList',
    component: () => import('@/views/apply/user/list'),
    meta: {
      title: '用户列表',
      headType: 0,
      auth: true
    }
  },
  {
    path: '/admin/apply/user/grade',
    name: 'UserGrade',
    component: () => import('@/views/apply/user/grade'),
    meta: {
      title: '用户等级',
      headType: 0,
      auth: true
    }
  },
  {
    path: '/admin/apply/user/settings',
    name: 'UserSettings',
    component: () => import('@/views/apply/user/settings'),
    meta: {
      title: '用户设置',
      headType: 0,
      auth: true
    }
  },
  {
    path: '/admin/apply/user/grade/details',
    name: 'GradeDetails',
    component: () => import('@/views/apply/user/grade_details'),
    meta: {
      title: '等级详情',
      headType: 0,
      auth: true
    }
  },
  {
    path: '/admin/apply/user/details',
    name: 'GradeEdit',
    component: () => import('@/views/apply/user/user_details'),
    meta: {
      title: '用户详情',
      headType: 0,
      auth: true
    }
  },
  {
    path: '/admin/apply/user/tag',
    name: 'UserTag',
    component: () => import('@/views/apply/user/user_tag'),
    meta: {
      title: '用户标签',
      headType: 0,
      auth: true
    }
  }
]



// WEBPACK FOOTER //
// ./src/router/apply/user.js